export const initialAbility = [
  {
    action: 'read',
    subject: 'guest',
  },
]

export const _ = undefined
